import axiosInstance from "../../../helpers/api";

export const getAllCourses = (body) => {
  return axiosInstance.get("/superadmin/courses", body);
};

export const editCourses = (formData) => {
  return axiosInstance.post(
    `/superadmin/courses/${formData.id}`,
    formData.formData
  );
};

export const restrictCourses = (formData) => {
  return axiosInstance.put(
    `/superadmin/courses/restrict/${formData.id}`,
    formData.formData
  );
};
export const asquaraCourses = (formData) => {
  return axiosInstance.post(
    `/superadmin/courses/set_asquera/${formData.id}`,
    formData.formData
  );
};
export const activeCourses = (formData) => {
  return axiosInstance.post(
    `/superadmin/courses/activate/${formData.id}`,
    formData.formData
  );
};

export const createCourses = (formData) => {
  return axiosInstance.post("/superadmin/courses", formData);
};

export const deleteCourse = (id) => {
  return axiosInstance.delete(`/superadmin/courses/${id}`);
};

export const approveStudentEnrollRequest = (formData) => {
  return axiosInstance.put(
    `/superadmin/courses/enroll-requests/approve`,
    formData?.data
  );
};

export const rejectStudentEnrollRequest = (formData) => {
  return axiosInstance.put(
    `/superadmin/courses/enroll-requests/reject`,
    formData?.data
  );
};

export const getAllEnrollCourse = (id) => {
  return axiosInstance.get(
    `/superadmin/courses/enroll-requests?course_id=${id}`
  );
};
